import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * shadcn/ui class-name helper: join conditional classes and dedupe conflicting
 * Tailwind utilities (the later one wins). Non-Tailwind class strings pass
 * through unchanged, so this stays backward-compatible with existing callers.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
